import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import ReactMapGL, { Marker, Popup, Source, Layer } from "react-map-gl";
import LocationOnIcon from "@mui/icons-material/LocationOn";

import "mapbox-gl/dist/mapbox-gl.css";

import MarkerPopup from "../MarkerPopup/MarkerPopup";

import "./MapContainer.css";

import { fetchVillagesSuccess } from "../../redux/reducers/villages";
import { fetchVillageCountDetailsSuccess } from "../../redux/reducers/villageCount";
import {
  fetchSelectedVillageMarkerSuccess,
  setSelectedMarkerImage,
  resetSelectedVillageMarker
} from "../../redux/reducers/selectedVillageMarker";
import {
  setSidebarVisibility,
  fetchSelectedVillageDetailsSuccess,
} from "../../redux/reducers/selectedVillageDetails";
import { useAuth0 } from "@auth0/auth0-react";
import SidebarVillageDetails from "../SidebarVillageDetails/SidebarVillageDetails";

const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

function MapContainer(props) {
  const defaultViewPort = {
    latitude: 28.836927000000003,
    longitude: 78.79018300000001,
    zoom: 14,
  };
  const [viewPort, setViewport] = useState(defaultViewPort);
  const [showPopup, setShowPopup] = useState(false);
  const changeMap = useSelector((state) => state.mapViews) || "";

  const landParcelDetails = useSelector(
    (state) => state.villageLandParcelDetails
  );
  const villageSitesDetails = useSelector((state) => state.villageSitesDetails);
  const villageSitesDetailsArray = Object.values(villageSitesDetails.data);
  const villageDetails = useSelector((state) => state.villageDetails);

  const selectedVillage = useSelector((state) => state.selectedVillageDetails);
  const selectedOwnership = useSelector(
    (state) => state.villageDetails.selectedOwnership
  );
  const selectedSiteInfo = useSelector(
    (state) => state.selectedVillageMarker.data
  );
  const selectedSiteId = selectedSiteInfo ? selectedSiteInfo.id : null;
  const selectedSiteImage = useSelector(
    (state) => state.selectedVillageMarker.markerImage
  );
  const minSize = process.env.REACT_APP_MIN_SIZE;
  const maxSize = process.env.REACT_APP_MAX_SIZE;
  console.log("land parcel details are", landParcelDetails);

  const dispatch = useDispatch();

  const handleClick = (event) => {
    const features = event.features; // Get all clicked features

    if (!features || features.length === 0) return;

    const villageFeatures = features.filter((feature) =>
      feature.layer.id.startsWith("village-")
    );
    const landParcelFeatures = features.filter((feature) =>
      feature.layer.id.startsWith("parcel-")
    );

    // Dispatch actions based on the clicked feature(s)
    if (villageFeatures.length > 0 && landParcelFeatures.length > 0) {
      const villageData = villageFeatures.map((f) => f.properties);
      const landParcelData = landParcelFeatures.map((f) => f.properties);

      dispatch(setSidebarVisibility(true));
      dispatch(fetchSelectedVillageDetailsSuccess(villageData[0]));

      setShowPopup(true);
      //setSelectedSiteInfo(landParcelData[0]);
      dispatch(fetchSelectedVillageMarkerSuccess(landParcelData[0]));
      dispatch(setSelectedMarkerImage(null));
      fetchSiteImage(
        (data) => {
          //setSelectedSiteImage(data);
          dispatch(setSelectedMarkerImage(data));
        },
        landParcelData[0].id,
        "land_parcel"
      );

      console.log("Village Details:", villageData);
      console.log("land_parcel details:", landParcelData);
      console.log("Land Parcel longotude:", landParcelData[0]?.land_longitude);
      console.log("Land Parcel latitude:", landParcelData[0]?.land_latitude);
    } else if (villageFeatures.length > 0) {
      const villageData = villageFeatures[0].properties;

      dispatch(setSidebarVisibility(true));
      dispatch(fetchSelectedVillageDetailsSuccess(villageData));

      console.log("Village Details:", villageData);
    } else if (landParcelFeatures.length > 0) {
      const landParcelData = landParcelFeatures[0].properties;

      setShowPopup(true);
      //setSelectedSiteInfo(landParcelData[0]);
      dispatch(fetchSelectedVillageMarkerSuccess(landParcelData[0]));
      dispatch(setSelectedMarkerImage(null));
      fetchSiteImage(
        (data) => {
          //setSelectedSiteImage(data);
          dispatch(setSelectedMarkerImage(data));
        },
        landParcelData[0].id,
        "land_parcel"
      );

      console.log("Land Parcel Details:", landParcelData);
    }
  };

  const handleMarkerClick = (event, mapMarker) => {
    // deep copy the selectedMarker object

    // const newSelectedMarker = JSON.parse(JSON.stringify(mapMarker));
    // console.log("New Selector Data", newSelectedMarker);
    setShowPopup(true);
    event.originalEvent.stopPropagation();
    //setSelectedSiteId(mapMarker.id);
    //setSelectedSiteInfo(mapMarker);
    dispatch(fetchSelectedVillageMarkerSuccess(mapMarker));
    dispatch(setSelectedMarkerImage(null));
    fetchSiteImage(
      (data) => {
        //setSelectedSiteImage(data);
        dispatch(setSelectedMarkerImage(data));
      },
      mapMarker.id,
      "sites"
    );
    // handleSidebarTypeChange(mapMarker, null);
    // dispatch(setSiteImage(null));

    // try {
    //   fetchSiteImage(mapMarker.ID, (data) => {
    //     handleSidebarTypeChange(mapMarker, data);
    //   });
    // } catch (error) {
    //   console.error("Error: Something went wrong");
    // }
    console.log("site type is ", typeof mapMarker);
  };

  function calculateCentroid(coords) {
    // console.log("coords", coords);
    const numCoords = coords.length;

    // Calculate the sum of latitudes and longitudes
    let sumLat = 0;
    let sumLong = 0;

    coords.forEach((coord) => {
      sumLat += coord.Latitude;
      sumLong += coord.Longitude;
    });

    // Calculate the average latitudes and longitudes
    const avgLat = sumLat / numCoords;
    const avgLong = sumLong / numCoords;

    return { latitude: avgLat, longitude: avgLong };
  }

  const { user, getAccessTokenSilently, getAccessTokenWithPopup } = useAuth0();

  const fetchDistinctVillages = async (callback) => {
    // check for local storage data
    const villagesLocalData = localStorage.getItem("villagesData");
    if (villagesLocalData) {
      console.log("found Village data in local storage");
      callback(JSON.parse(villagesLocalData));
    } else {
      console.log("no data found in local storage for Village");
    }

    const accessToken = await getAccessTokenSilently({
      authorizationParams: {
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      },
    });

    const url = process.env.REACT_APP_API_BASE_URL + `/get_villages`;
    const authToken = accessToken; // Replace with your actual authorization token

    fetch(url, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        // Set the data in local storage
        localStorage.setItem("villagesData", JSON.stringify(data));

        if (villagesLocalData) {
          return;
        }

        // Process the retrieved data here
        callback(data);
      })
      .catch((error) => {
        // Handle any errors that occurred during the request
        console.error("Error: Something went wrong");
      });
  };

  const fetchVillageCount = async (
    callback,
    minSiteSize = minSize,
    maxSiteSize = maxSize,
    minLPsize = minSize,
    maxLPsize = maxSize
  ) => {
    try {
      const accessToken = await getAccessTokenSilently({
        authorizationParams: {
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        },
      });

      const url = `${process.env.REACT_APP_API_BASE_URL}/get_village_count?minSiteSize=${minSiteSize}&maxSiteSize=${maxSiteSize}&minLPsize=${minLPsize}&maxLPsize=${maxLPsize}`;

      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      callback(data);
    } catch (error) {
      console.error("Error: Something went wrong", error);
    }
  };

  const fetchSiteImage = async (callback, siteID, land_type) => {
    const accessToken = await getAccessTokenSilently({
      authorizationParams: {
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      },
    });

    const url =
      process.env.REACT_APP_API_BASE_URL +
      `/get_land_revenue_images?land_type=${land_type}&site_id=${siteID}`;
    const authToken = accessToken; // Replace with your actual authorization token

    fetch(url, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        // Process the retrieved data here
        callback(data);
      })
      .catch((error) => {
        // Handle any errors that occurred during the request
        console.error("Error: Something went wrong");
      });
  };

  const setDefaultViewPort = (filteredData) => {
    const currCentroid = calculateCentroid(filteredData);
    // console.log("currCentroid", currCentroid);
    if (currCentroid.longitude && currCentroid.latitude) {
      setViewport({
        ...viewPort,
        longitude: currCentroid.longitude,
        latitude: currCentroid.latitude,
        zoom: defaultViewPort.zoom,
      });
    } else {
      setViewport(viewPort);
    }
  };

  useEffect(() => {
    if (Object.values(villageDetails.data).length > 0) {
      const firstZone = Object.values(villageDetails.data)[0]; // Pick first zone
      setViewport((prev) => ({
        ...prev,
        longitude: firstZone.village_longitude,
        latitude: firstZone.village_latitude,
        zoom: defaultViewPort.zoom,
      }));
    }
  }, [villageDetails.data]);

  useEffect(() => {
    fetchDistinctVillages((data) => {
      dispatch(fetchVillagesSuccess(data));
    });
    fetchVillageCount((data) => {
      dispatch(fetchVillageCountDetailsSuccess(data));
    });
  }, []);

  return (
    <ReactMapGL
      {...viewPort}
      onMove={(evt) => setViewport(evt.viewState)}
      className="map-container"
      style={{ height: "100vh" }}
      projection={"globe"}
      reuseMaps
      attributionControl={false}
      mapStyle={changeMap.value}
      mapboxAccessToken={MAPBOX_ACCESS_TOKEN}
      interactiveLayerIds={[
        ...Object.values(villageDetails.data).map(
          (zone) => `village-${zone.id}`
        ),
        ...Object.values(landParcelDetails.data).map(
          (land) => `parcel-${land.id}`
        ),
      ]}
      onClick={handleClick} // Detect clicks inside polygons
    >
      {selectedVillage.showSidebar && <SidebarVillageDetails />}

      {/* Add the Villages */}
      {Object.values(villageDetails.data).length > 0 &&
        Object.values(villageDetails.data).map((zone) => {
          return (
            <ZonePolygon
              key={`village-${zone.id}`}
              zoneData={zone}
              layerFill={zone.gov_status === "government" ? "green" : "white"} // Highlight selected village
              lineWidth={zone.gov_status === "government" ? 2 : 2}
              dotted={false}
            />
          );
        })}

      {/*add land parcel*/}
      {selectedVillage.selectedType["Land Parcel"] &&
        Object.values(landParcelDetails.data).length > 0 &&
        Object.values(landParcelDetails.data)
          .filter(
            (land) =>
              parseInt(land.land_size) >=
                selectedVillage.selectMinMaxOfSize[0] &&
              parseInt(land.land_size) <=
                selectedVillage.selectMinMaxOfSize[1] &&
              selectedOwnership[land.gov_status]
          )
          .map((land) => (
            <LandParcelPolygon
              key={`parcel-${land.id}`}
              parcelData={land}
              layerFill={
                land.gov_status === "government"
                  ? "rgba(130, 238, 118, 0.94)"
                  : "white"
              } // Highlight selected village
              lineWidth={2}
              dotted={false}
            />
          ))}

      {selectedVillage.selectedType["Construction"] &&
        villageSitesDetailsArray &&
        villageSitesDetailsArray.length > 0 &&
        villageSitesDetailsArray
          .filter(
            (site) =>
              parseInt(site.site_size) >=
                selectedVillage.selectMinMaxOfSize[0] &&
              parseInt(site.site_size) <=
                selectedVillage.selectMinMaxOfSize[1] &&
              selectedOwnership[site.gov_status]
          )
          .map((site) => (
            <Marker
              key={site.id}
              longitude={site.site_longitude}
              latitude={site.site_latitude}
              onClick={(evt) => handleMarkerClick(evt, site)}
            >
              {
                <LocationOnIcon
                  style={{
                    color:
                      selectedSiteId !== null && selectedSiteId === site.id
                        ? site.gov_status === "government"
                          ? "rgba(130, 238, 118, 0.94)"
                          : "white"
                        : site.gov_status === "government"
                        ? "rgba(130, 238, 118, 0.94)"
                        : "white",
                    background:
                      selectedSiteId !== null && selectedSiteId === site.id
                        ? "rgba(0, 0, 0, 0.5)"
                        : "transparent",
                    padding:
                      selectedSiteId !== null && selectedSiteId === site.id
                        ? "0.5rem"
                        : "0",
                    borderRadius:
                      selectedSiteId !== null && selectedSiteId === site.id
                        ? "50%"
                        : "0",
                    fontSize: "1rem",
                  }}
                />
              }
            </Marker>
          ))}

      {showPopup && selectedSiteInfo && (
        <Popup
          longitude={
            selectedSiteInfo.site_longitude || selectedSiteInfo.land_longitude
          }
          latitude={
            selectedSiteInfo.site_latitude || selectedSiteInfo.land_latitude
          }
          offset={10}
          closeOnClick={false}
          closeOnMove={false}
          anchor="left"
          className="custom-map-popup"
        >
          <MarkerPopup
            popupCoordinates={selectedSiteInfo}
            siteImage={selectedSiteImage}
            setShowPopup={setShowPopup}
          />
        </Popup>
      )}
    </ReactMapGL>
  );
}

// const ZonePolygon = ({ zoneData, layerFill }) => {
//   // console.log("zone polygon", layerFill);
//   console.log("Polygon geometry: ", zoneData.geometry);
//   return (
//     <Source
//       type="geojson"
//       data={{
//         type: "Feature",
//         geometry: zoneData.geometry,
//       }}
//     >
//       <Layer
//         type="fill"
//         paint={{
//           "fill-color": layerFill,
//           "fill-opacity": 0.3,
//         }}
//       />
//     </Source>
//   );
// };

// const ZonePolygon = ({ zoneData, layerFill, lineWidth, dotted }) => {
//   return (
//     <Source
//       type="geojson"
//       data={{
//         type: "Feature",
//         geometry: zoneData.geometry,
//       }}
//     >
//       <Layer
//         type="line"
//         paint={{
//           "line-color": layerFill,
//           "line-width": lineWidth,
//           ...(dotted && { "line-dasharray": [2, 2] }),
//         }}
//       />
//     </Source>
//   );
// };

const ZonePolygon = ({ zoneData, layerFill, lineWidth, dotted }) => {
  return (
    <Source
      id={`zone-${zoneData.id}`}
      type="geojson"
      data={{
        type: "Feature",
        geometry: zoneData.village_geometry,
        properties: { ...zoneData }, // Attach village properties
      }}
    >
      <Layer
        id={`village-${zoneData.id}`}
        type="fill"
        paint={{
          "fill-color": "#000000",
          "fill-opacity": 0,
        }}
      />

      <Layer
        type="line"
        paint={{
          "line-color": layerFill,
          "line-width": lineWidth,
          ...(dotted && { "line-dasharray": [2, 2] }),
        }}
      />
    </Source>
  );
};

const LandParcelPolygon = ({ parcelData, layerFill, lineWidth, dotted }) => {
  return (
    <Source
      id={`land-${parcelData.id}`}
      type="geojson"
      data={{
        type: "Feature",
        //geometry: parcelData.land_geometry,
        geometry:
          typeof parcelData.land_geometry === "string"
            ? JSON.parse(parcelData.land_geometry)
            : parcelData.land_geometry,
        properties: { ...parcelData }, // Attach village properties
      }}
    >
      <Layer
        id={`parcel-${parcelData.id}`}
        type="fill"
        paint={{
          "fill-color": layerFill,
          "fill-opacity": 0.8,
        }}
      />

      <Layer
        type="line"
        paint={{
          "line-color": layerFill,
          "line-width": lineWidth,
          ...(dotted && { "line-dasharray": [2, 2] }),
        }}
      />
    </Source>
  );
};

export default MapContainer;
